import { BetSelection } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betSelectionDictionary = createSimpleDictionary([
    { id: BetSelection.HandicapHome, name: 'dictionaries.betSelection.handicapHome' },
    { id: BetSelection.HandicapAway, name: 'dictionaries.betSelection.handicapAway' },
    { id: BetSelection.GoalOver, name: 'dictionaries.betSelection.goalOver' },
    { id: BetSelection.GoalUnder, name: 'dictionaries.betSelection.goalUnder' },
    { id: BetSelection.OneXTwoHome, name: 'dictionaries.betSelection.oneXTwoHome' },
    { id: BetSelection.OneXTwoDraw, name: 'dictionaries.betSelection.oneXTwoDraw' },
    { id: BetSelection.OneXTwoAway, name: 'dictionaries.betSelection.oneXTwoAway' },
    { id: BetSelection.BtsYes, name: 'dictionaries.betSelection.btsYes' },
    { id: BetSelection.BtsNo, name: 'dictionaries.betSelection.btsNo' },
    { id: BetSelection.Dc1X, name: 'dictionaries.betSelection.dc1X' },
    { id: BetSelection.Dc12, name: 'dictionaries.betSelection.dc12' },
    { id: BetSelection.DcX2, name: 'dictionaries.betSelection.dcX2' },
    { id: BetSelection.Cs, name: 'dictionaries.betSelection.cs' },
    { id: BetSelection.CornersHandicapHome, name: 'dictionaries.betSelection.cornersHandicapHome' },
    { id: BetSelection.CornersHandicapAway, name: 'dictionaries.betSelection.cornersHandicapAway' },
    { id: BetSelection.CornersGoalOver, name: 'dictionaries.betSelection.cornersGoalOver' },
    { id: BetSelection.CornersGoalUnder, name: 'dictionaries.betSelection.cornersGoalUnder' },
]);
